export type UnwrapReactComponent<T> = T extends React.FC<infer U> ? U : T;

// For backwards compatibility
// In older versions of React, React.FC included { children } prop by default
// and it was a way to have a component without any children allowed
// by now, it's the default so it's 1:1 with React.FC
export type ReactTFC<P = object> = React.FC<P>;

export function notNullPredicate<T>(t: T | null | undefined): t is T {
  return t !== null && typeof t !== "undefined";
}

export function head<A>(arr: Array<A>): A | undefined {
  return arr[0];
}
